import { ControlSize } from "shared/enums/ControlSizeEnum";
export const getSizeSpecificClasses = (size?: ControlSize) => {
  let className = "h-10";
  if (size && size === ControlSize.Large) {
    return "h-53px";
  }

  if (size && size === ControlSize.Small) {
    return "h-9";
  }

  return className;
};

export const getControlRadius = (radiusSize?: ControlSize) => {
  let className = "rounded-sm";
  if (radiusSize && radiusSize === ControlSize.Midium) {
    return "rounded";
  }

  if (radiusSize && radiusSize === ControlSize.Large) {
    return "rounded-lg";
  }

  return className;
};
